/**
 * Message 全局服务
 * 用于在非组件中（如 axios 拦截器）显示消息提示
 */
import { MessageInstance } from 'antd/es/message/interface'

let messageInstance: MessageInstance | null = null

const GLOBAL_ERROR_MESSAGE_KEY = 'global-request-error'
const ERROR_DEDUPE_WINDOW_MS = 1500

let lastErrorContent = ''
let lastErrorAt = 0

/**
 * 注册 message 实例
 */
export const registerMessage = (instance: MessageInstance) => {
  messageInstance = instance
}

/**
 * 显示成功消息
 */
export const showMessage = {
  success: (content: string) => {
    messageInstance?.success(content)
  },
  error: (content: string) => {
    if (!messageInstance) return

    const now = Date.now()
    if (content === lastErrorContent && now - lastErrorAt < ERROR_DEDUPE_WINDOW_MS) {
      return
    }

    lastErrorContent = content
    lastErrorAt = now

    messageInstance.open({
      key: GLOBAL_ERROR_MESSAGE_KEY,
      type: 'error',
      content,
    })
  },
  warning: (content: string) => {
    messageInstance?.warning(content)
  },
  info: (content: string) => {
    messageInstance?.info(content)
  },
}
